import { render, staticRenderFns } from "./EditarContratoProveedorModal.vue?vue&type=template&id=35ab2b22&"
import script from "./EditarContratoProveedorModal.vue?vue&type=script&lang=ts&"
export * from "./EditarContratoProveedorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports